export default [
  { value: 'Action', label: 'Action' },
  { value: 'Action and Adventure', label: 'Action and Adventure' },
  { value: 'Adventure', label: 'Adventure' },
  { value: 'Animation', label: 'Animation' },
  { value: 'Anime', label: 'Anime' },
  { value: 'Awards Show', label: 'Awards Show' },
  { value: 'Children', label: 'Children' },
  { value: 'Comedy', label: 'Comedy' },
  { value: 'Crime', label: 'Crime' },
  { value: 'Documentary', label: 'Documentary' },
  { value: 'Drama', label: 'Drama' },
  { value: 'Family', label: 'Family' },
  { value: 'Fantasy', label: 'Fantasy' },
  { value: 'Food', label: 'Food' },
  { value: 'Game Show', label: 'Game Show' },
  { value: 'History', label: 'History' },
  { value: 'Home and Garden', label: 'Home and Garden' },
  { value: 'Horror', label: 'Horror' },
  { value: 'Indie', label: 'Indie' },
  { value: 'Martial Arts', label: 'Martial Arts' },
  { value: 'Mini-Series', label: 'Mini-Series' },
  { value: 'Musical', label: 'Musical' },
  { value: 'Mystery', label: 'Mystery' },
  { value: 'News', label: 'News' },
  { value: 'Podcast', label: 'Podcast' },
  { value: 'Reality', label: 'Reality' },
  { value: 'Romance', label: 'Romance' },
  { value: 'Science Fiction', label: 'Science Fiction' },
  { value: 'Soap', label: 'Soap' },
  { value: 'Special Interest', label: 'Special Interest' },
  { value: 'Sport', label: 'Sport' },
  { value: 'Suspense', label: 'Suspense' },
  { value: 'Talk Show', label: 'Talk Show' },
  { value: 'Thriller', label: 'Thriller' },
  { value: 'Travel', label: 'Travel' },
  { value: 'Variety', label: 'Variety' },
  { value: 'War', label: 'War' },
  { value: 'Web Series', label: 'Web Series' },
  { value: 'Western', label: 'Western' }
];
